import { useState, useEffect, useCallback } from 'react';

export const useAudioPlayer = () => {
  const [isPlaying, setIsPlaying] = useState(false);
  const [currentAudio, setCurrentAudio] = useState(null);
  const [currentId, setCurrentId] = useState(null);
  const [error, setError] = useState(null);

  const play = useCallback(async (url, id, volume = 1) => {
    try {
      if (currentAudio) {
        currentAudio.pause();
        currentAudio.currentTime = 0;
      }

      const audio = new Audio(url);
      audio.volume = volume;
      
      audio.onended = () => {
        setIsPlaying(false);
        setCurrentId(null);
      };

      await audio.play();
      setCurrentAudio(audio);
      setCurrentId(id);
      setIsPlaying(true);
      setError(null);
    } catch (err) {
      setError('Failed to play audio');
      setIsPlaying(false);
      setCurrentId(null);
    }
  }, [currentAudio]);

  const stop = useCallback(() => {
    if (currentAudio) {
      currentAudio.pause();
      currentAudio.currentTime = 0;
      setIsPlaying(false);
      setCurrentId(null);
    }
  }, [currentAudio]);

  useEffect(() => {
    return () => {
      if (currentAudio) {
        currentAudio.pause();
        currentAudio.src = '';
      }
    };
  }, [currentAudio]);

  return { play, stop, isPlaying, currentId, error };
};